import styled from 'styled-components';

export const PostEditModalStyleStyle = styled.div`
    position: fixed;
    display: flex;
    align-items:center;
    justify-content:center;
    background-color:#777777CC;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 10;
    padding: 0 1rem;


`